// extracted by mini-css-extract-plugin
module.exports = {"carousel-changes":"catCarousel_carousel-changes__GgkKz"};